import React from 'react';
import ReactDOM from 'react-dom/client';
import { StoreProvider } from 'easy-peasy';
import store from '../src/store';
import './index.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import App from './App';
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom';
// import AdminPatientHealthFormNew from './web/AdminView/AdminPatientHealthFormNew';
// import reportWebVitals from './reportWebVitals';

const router = createBrowserRouter(createRoutesFromElements(<Route path='*' element={<App />} />));

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <StoreProvider store={store}>
    {/* <link rel="stylesheet" type="text/css" href='./App.css' /> */}
    {/* <App /> */}
    <RouterProvider router={router} />
    {/* <AdminPatientHealthFormNew /> */}
  </StoreProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
